var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeconnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 0H9.5625V10.5882H7.4375V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8044 4.11882L13.345 2.58353C15.555 4.10824 17 6.64941 17 9.52941C17 14.2094 13.1962 18 8.5 18C3.80375 18 0 14.2094 0 9.52941C0 6.64941 1.445 4.10824 3.655 2.58353L5.185 4.10824C3.3575 5.23059 2.125 7.23176 2.125 9.52941C2.125 13.0341 4.98313 15.8824 8.5 15.8824C12.0169 15.8824 14.875 13.0341 14.875 9.52941C14.875 7.23176 13.6425 5.23059 11.8044 4.11882Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeconnection);
export default __webpack_public_path__ + "static/media/deconnection.7611e3e493a6c6f32db388950d5ea867.svg";
export { ForwardRef as ReactComponent };